<template>
  <div class="w-100 h-100">
    <div v-show="loading" class="flex justify-center items-center total-height">
      <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
    </div>
    <div class="news-container w-100 h-100 flex" v-show="!loading">
      <div class="img-1 w-40 h-100 cover center background-center flex items-center" :style=" { 'background-image': 'url(' + this.img1URL + ')' }">
      </div>
      <div class="news-container-2 flex flex-column w-60 h-100">
        <div class="news-content w-100 flex flex-column pa4">
          <div class="news-header">
            <h2 class="mb1 mt1 textColor">{{news.title}}</h2>
            <p class="i ma0 textColor">{{news.subtitle}}</p>
          </div>
            <p class="news-text textColor" v-html="news.text"></p>
        </div>
        <div class="img-2 w-100 h-100 cover center background-center flex items-center" :style=" { 'background-image': 'url(' + this.img2URL + ')' }">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import consts from '@/consts'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

  export default {
    name: 'news',
    components: {ClipLoader},
    data () {
      return {
        news: Object,
        color: '#808080',
        size: '100px',
        loading: true,
        img1URL: String,
        img2URL: String
      }
    },
    created () {
      this.$http.get(`${consts.API_BASE_URL}/news/get/${this.$route.params.id}`)
        .then(res => {
          this.news = res.body.data
          this.img1URL = consts.MEDIA_BASE_URL + this.news.path + this.news.image
          this.img2URL = consts.MEDIA_BASE_URL + this.news.path + this.news.image1
          this.loading = false
        })
    }
  }
</script>

<style lang="scss">
  @import '~@/variables.scss';

  .news-content {
    height: 85%
  }
  .img-2 {
    height: 15%;
  }
  .news-text{
    overflow-y: scroll;
    overflow-x: hidden;
    margin-bottom: 0;
  }

  a{
    color: #fff !important;
  }


  @media (max-width: 479px) {
    .news-container {
      flex-direction: column;
    }
    .img-1 {
      width: 40%;
      height: 40%;
    }
    .news-container-2 {
      width: 100% !important;
    }
    .news-content{
      padding: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news/News.vue